import React from "react";
import { languages } from "../../../constants/languages";
import diaPicture from "../../../img/present.png";
import Typography from "@material-ui/core/Typography";
import EditDiaContainer from "../../../containers/settings/slideshow/EditDiaContainer";

const NoDiasMessage = (props) => (
  <div style={{ width: "95%", textAlign: "center", marginTop: 80 }}>
    <div style={{ maxWidth: 700, display: "inline-block" }}>
      <img
        src={diaPicture}
        alt=""
        style={{ height: 100, margin: "20px 0 15px 0" }}
      />
      <Typography variant="h6">{languages.present.presentTitle}</Typography>
      <Typography variant="subtitle1" style={{ fontSize: 17 }}>
        {languages.present.presentDescription}
      </Typography>
      <div style={{ display: "inline-block", margin: "15px 15px 0 15px" }}>
        <EditDiaContainer
          tournament={props.tournament}
          firstDia={true}
          dias={props.dias}
          selectedSlideshow={props.selectedSlideshow}
          days={[]}
          daysByKey={{}}
        />
      </div>
    </div>
  </div>
);

export default NoDiasMessage;
